import clsx from 'clsx';
import React from 'react';
import { PetType } from 'types/Pet';

import classes from './PetTypeChip.module.scss';

interface PetTypeChipProps {
    petType: PetType;
}

export const PetTypeChip: React.FC<PetTypeChipProps> = props => {
    return (
        <span className={clsx(classes.root, classes[props.petType.id])}>
            {props.petType.singular}
        </span>
    );
};
